import styled from 'styled-components';
import { Icon, IconButton } from '@web-chat-core/ui-kit';
import { toggleHideWithOpacityAnimation } from 'ui/mixins';

export const FullscreenButtonView = styled(IconButton)<{ $hidden: boolean }>`
    position: absolute;
    bottom: 28px;
    right: 28px;

    &:before {
        background-color: ${(props) => props.theme.root.colors.basicColors.black['50%']};
    }

    &:hover:before {
        background-color: ${(props) => props.theme.root.colors.basicColors.black['24%']};
    }

    &:after {
        right: 0;
        left: auto;
        transform: translateY(-100%);
        white-space: nowrap;
    }

    ${({ $hidden }) => toggleHideWithOpacityAnimation($hidden)};
`;

export const FullscreenIcon = styled(Icon)`
    position: relative;
`;
